import React from 'react';

const Loading = () => {
  return (
    <div className="flex items-center justify-center min-h-[200px]">
      <div className="flex flex-col items-center">
        {/* Loading spinner */}
        <div className="relative w-12 h-12">
          <div className="absolute top-0 left-0 w-full h-full border-2 border-gray-200 rounded-full"></div>
          <div className="absolute top-0 left-0 w-full h-full border-2 border-t-[#E16811] rounded-full animate-spin"></div>
        </div>
        
        {/* Loading text */}
        <p className="mt-3 text-sm text-gray-500">Loading...</p>
      </div>
    </div>
  );
};

export default Loading; 